export const HiddenFields = {
  bigLists: [
    'Username',
    'Sequence number',
    'Status',
    'Short Text neutral',
    'Short text aus Dec"1"',
    'Short text aus Dec"2"',
    'Short Text Adjourned',
    'Prolongation, Date',
    'Display Prolo Fields',
    'Audit Definite:',
    'Special Audit',
    'Basic Defs:',
    'Date actual Deadline',
    'Prolo Decision, Date other Deadline',
    'Decision, Save:',
    'Names list',
    'Names list',
    'Name of last modifier',
    'Date of last modification'
  ],
  smallLists: [
    'Authors Reco Assessor',
    'Authors Reco Auditor',
    'Readers defined Responsibilities',
    'Readers LU',
    'Readers BU'
  ],
  smallSecondValues: [
    'Write access for Auditor / Coordinator (1 Person)',
    'Write access for Auditor ("Team" Role)',
    'Read access for defined (LU) Responsibles of Recommendation',
    'Read access for LU role',
    'Read access for BG role'
  ]
};
